<template>
    <div class="report-container">
        <!-- <div class="bg-decoration ball-1"></div>
        <div class="bg-decoration ball-2"></div> -->
        
        <!-- <div class="overlay"></div> -->

        <div class="content-wrapper">
            <header class="header-section fade-in-down">
                <div class="greeting-box">
                    <p class="greeting-text">
                        Hi~ <span class="student-name">{{ ReportData.stuname }}</span>
                    </p>
                    <!-- <div class="status-badge">学习旅伴已就绪</div> -->
                </div>
                <p class="sub-greeting">我们又见面啦~</p>
            </header>

            <main class="message-card-wrapper fade-in-up">
                <div class="glass-card">
                    <div class="card-header">
                        <span class="date-tag">2026 · April</span>
                        <div class="line-decorator"></div>
                    </div>
                    
                    <div class="quote-group">
                        <p class="anim-line">我们一起走过新的学习阶段。</p>
                        <p class="anim-line">也在不知不觉中走得更远了一点。</p>
                        <p class="anim-line">感谢你持续投入，让学习成为一种习惯。</p>
                        <p class="anim-line" v-show="ReportData.studate">四月你在富学宝典平台上学习了<span class="highlight-quote">{{ ReportData.studate }}</span>天</p>
                        <div v-show="ReportData.playtime">
                            <p class="anim-line">累计学习了<span class="highlight-quote">{{ ReportData.playtime }}</span>小时</p>
                            <!-- <div class="pulse-dot"></div> -->
                        </div>
                        <p class="anim-line emphasis">当工作告一段落，</p>
                        <p class="anim-line emphasis">学习，可以慢慢开始。</p>
                    </div>
                </div>
            </main>

            <!-- <footer class="footer-hint fade-in">
                <p>一月的学习报告已为你生成</p>
                <div class="swipe-container">
                    <div class="mouse-icon">
                        <div class="wheel"></div>
                    </div>
                    <span class="swipe-text">左滑开启新篇章</span>
                </div>
            </footer> -->
			<footer class="footer-hint fade-in">
                <p>四月的学习报告已为你生成</p>
                <div class="swipe-guide">
                    <span class="arrow">‹</span>
                    <span>左滑查看更多内容</span>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: ["ReportData"]
}
</script>

<style scoped>

.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: #0f172a;
    background: 
        url("../../assets/26April/logo.png") right top no-repeat,
        url("../../assets/26April/bg.jpg") no-repeat;
    background-size: 100% 100%, cover;
    width: 100%;
    height: 100vh;
    /* color: var(--text-light); */
    font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

.content-wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    padding: 8vh 5% 6vh;
    box-sizing: border-box;
}

.message-card-wrapper {
    margin-top: 8vh;
}

/* --- 头部设计 --- */
.greeting-box {
    display: flex;
    align-items: baseline;
    gap: 8px;
}

.student-name {
    margin-top: 2vh;
    font-size: 36px;
    font-weight: 800;
    /* color: #5C2E2E; */
    background: #FFFFFF;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /* text-shadow: 0 4px 20px rgba(34, 197, 94, 0.5); */
    letter-spacing: 1px;
}

.sub-greeting {
    margin-top: 8px;
    letter-spacing: 6px;
    font-weight: 600;
    color: #5C2E2E;
    opacity: 0.8;
    margin: 0;
    font-size: 15px;
}

/* --- 玻璃态卡片 --- */
.glass-card {
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(34, 197, 94, 0.2);
    border-radius: 28px;
    padding: 20px 24px;
    margin-top: -30px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

/* --- 卡片头部 --- */
.card-header {
    margin-bottom: 0px;
}

.date-tag {
    font-size: 20px;
    font-weight: 700;
    color: #000;
    letter-spacing: 3px;
}

.line-decorator {
    width: 40px;
    height: 4px;
    background: linear-gradient(90deg, var(--primary-green), var(--accent-cyan));
    margin: 10px 0 20px;
    border-radius: 3px;
}

/* --- 卡片内容 --- */
.anim-line {
    color: var(--text-dark);
    font-weight: 400;
    margin-top: -10px;
    font-size: 18px;
    line-height: 1.5;
}

.quote-group p {
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 10px;
    font-weight: 400;
}

.emphasis {
    font-size: 20px !important;
    font-weight: 600 !important;
    margin-top: 1px !important;
}

.text-gradient {
    background: linear-gradient(135deg, var(--primary-green), var(--primary-dark));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 700;
    padding: 0 6px;
}

.highlight-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 0;
    padding: 8px 12px;
    background: rgba(34, 197, 94, 0.1);
    border-radius: 12px;
    border: 1px solid rgba(34, 197, 94, 0.15);
}

.highlight-quote {
    margin: 0 !important;
    color: #ac9be2;
    font-weight: 800 !important;
    font-size: 26px !important;
}

/* 呼吸小点 */
.pulse-dot {
    width: 8px;
    height: 8px;
    background: var(--primary-green);
    border-radius: 50%;
    box-shadow: 0 0 15px var(--primary-green);
    animation: pulse 2s infinite;
}

/* --- 底部引导 --- */
.footer-hint {
    text-align: center;
    margin-top: auto;
    padding-top: 10px;
}

.footer-hint p {
    font-size: 15px;
    color: var(--text-light);
    opacity: 0.8;
    margin-bottom: 14px;
    font-weight: 500;
}

.swipe-guide {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 16px;
    color: var(--text-light);
    font-weight: 500;
    animation: moveLeft 1.5s infinite ease-in-out;
}

.swipe-guide .arrow {
    font-size: 20px;
    color: var(--accent-cyan);
}

/* --- 核心动画 --- */
@keyframes float {
    0% { transform: translate(0, 0) scale(1); }
    100% { transform: translate(20px, 30px) scale(1.1); }
}

@keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.6); opacity: 0.4; }
    100% { transform: scale(1); opacity: 1; }
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes moveLeft {
    0%, 100% { transform: translateX(0); opacity: 0.7; }
    50% { transform: translateX(-12px); opacity: 1; }
}

/* 逐行加载效果 */
.fade-in-up { animation: fadeInUp 1s ease-out both; }
.fade-in-down { animation: fadeInUp 1s ease-out both; }

.anim-line {
    opacity: 0;
    animation: fadeInUp 0.8s ease-out forwards;
}
.anim-line:nth-child(1) { animation-delay: 0.2s; }
.anim-line:nth-child(2) { animation-delay: 0.4s; }
.anim-line:nth-child(3) { animation-delay: 0.6s; }
.anim-line:nth-child(4) { animation-delay: 0.8s; }
.anim-line:nth-child(5) { animation-delay: 1.0s; }
.anim-line:nth-child(6) { animation-delay: 1.2s; }

/* PC 端适配优化 */
@media screen and (min-width: 786px) {
    .report-container {
        background-image: url("../../assets/26April/pcbg.jpg");
        background-size: cover;
    }

    .glass-card { 
        max-width: 550px; 
        margin: 0 auto; 
        padding: 60px 50px; 
    }
    .student-name { font-size: 56px; }
    .content-wrapper { align-items: center; }
    .sub-greeting { font-size: 18px; letter-spacing: 8px; }
}
</style>